// Two boats moored together (the office raft and its 活动舱): how one boat's 码头 / 跳板 lines up with the other's, so
// the people at one boat's edge can be shown on the other (src/office/edge.ts forwards them, public/neighbours.js draws
// them) and someone walking across lands where they were going (the handoff). Pure, no DOM: the office uses it too.
//
// Each boat has one portal to the other (deck/map.js portals), its water end facing south. The two meet water end to
// water end, the other boat turned round: a point's feet go to footThem + (footMe − feet). Turning round keeps
// distances, so who is within earshot is the same seen from either boat. The edge: the portal and the deck at its head
// (REACH tiles north of it, SIDE tiles either side); seen from the other boat it lands on what that map paints there
// (the raft's map: the moored ship; the 活动舱's: the raft's corner and its pier).

/** Tiles of deck north of the portal, and either side of it, that count as the boat's edge. */
export const REACH = 3, SIDE = 5; // (3: the 活动舱's spawn and both landing points stay outside, so an idle crowd there isn't forwarded)

/** The middle of a portal's water end (its south edge), in tiles. */
export const footOf = (q) => ({ x: q.x + q.w / 2, y: q.y + q.h });

/** A portal's edge: the rectangle (tiles) whose people the other boat sees. */
export const edgeOf = (q) => ({ x: q.x - SIDE, y: q.y - REACH, w: q.w + 2 * SIDE, h: q.h + REACH });

/** Is an otter at (x, y) (by its feet, as rules.ts feetIn) at portal q's edge? */
export function inEdge(q, x, y) {
  const e = edgeOf(q), fx = x + 0.5, fy = y + 0.8;
  return fx >= e.x && fx < e.x + e.w && fy >= e.y && fy < e.y + e.h;
}

/** The portal on this map to the other boat (`to`: "play", the 活动舱; "main", the office raft), or null. */
export const portalTo = (map, to) => (map?.portals ?? []).find((q) => q.to === to) ?? null;

/** An otter at {x, y, dir, dir8, dir16} by portal `from`, as seen from the boat whose portal is `to`: its position and
 *  its facing turned round. */
export function across(p, from, to) {
  const a = footOf(from), b = footOf(to);
  const n = (v, m) => (Number.isInteger(v) ? (((v + m / 2) % m) + m) % m : undefined);
  return {
    x: +(b.x + a.x - (p.x + 0.5) - 0.5).toFixed(3), y: +(b.y + a.y - (p.y + 0.8) - 0.8).toFixed(3),
    dir: n(p.dir, 4) ?? 0, dir8: n(p.dir8, 8), dir16: n(p.dir16, 16),
  };
}

/** A spot on portal q for someone arriving at (x, y) (already in this boat's frame): moved onto the portal's deck. */
export function ontoPortal(q, x, y) {
  const fx = Math.min(q.x + q.w - 0.3, Math.max(q.x + 0.3, x + 0.5)), fy = Math.min(q.y + q.h - 0.3, Math.max(q.y + 0.3, y + 0.8));
  return { x: +(fx - 0.5).toFixed(3), y: +(fy - 0.8).toFixed(3) };
}
